/*
 *
 * This file contains all the urls used in the code.
 *
 * */

import ContraceptivePill from "../components/pageComponents/DecisionAid/Hirsutism/Options/ContraceptivePill";

export const BACKEND_URL = `http://ask-pcos-application-fargate-alb-1540914250.ap-southeast-2.elb.amazonaws.com`;
//export const BACKEND_URL = `http://localhost:8000`
export const BACKEND_CMS_GQL_URL = `${BACKEND_URL}/graphql`;
export const BACKEND_CMS_REST_API_URL = `${BACKEND_URL}/api/rest/pages/`;

export const PCOS_MoreInfo_ExternalLink =
  "https://en.wikipedia.org/wiki/Polycystic_ovary_syndrome";
export const MCHRI_ExternalLink = "https://www.monash.edu/medicine/sphpm/mchri";
export const MonashHealth_ExternalLink = "https://monashhealth.org";
export const MonashUniversity_ExternalLink = "https://www.monash.edu/";
export const MCHRI_Facebook_ExternalLink =
  "https://www.facebook.com/monashmchri/";

export const HealthDirect_ExternalLink = "https://www.healthdirect.gov.au/";
export const TermsAndConditionsS3_ExternalLink =
  "https://askpcos-public-bucket.s3-ap-southeast-2.amazonaws.com/AskPCOS+consent%2C+terms+%26+conditions+and+disclaimer.pdf";

export const TermsAndConditionsUpdateS3_ExternalLink =
  "https://askpcos-public-bucket.s3-ap-southeast-2.amazonaws.com/AskPCOS+consent%2C+terms+%26+conditions+and+disclaimer.pdf";

export const DataProtectionAndPrivacyProcedure_ExternalLink =
  "https://www.monash.edu/__data/assets/pdf_file/0003/790086/Privacy.pdf";

export const MyDashboard_InternalLink = "/my-dashboard/";
export const Signup_InternalLink = "/sign-up/";
export const Login_InternalLink = "/log-in/";
export const DiscoveryPage_InternalLink = "/topics/";
export const QuestionPromptList_InternalLink = "/ask/qpl/";
export const SelfAssessment_InternalLink = "/ask/self-assessment/";
export const Lifestyle_InternalLink = "/ask/lifestyle/";
export const Logout_InternalLink = "/log-out/";
export const Profile_InternalLink = "/profile/";
export const DiscussionForum_InternalLink = "/discussion-forum/";
export const DiscussionForumStartTopic_InternalLink =
  "/discussion-forum/start-topic/";
export const DiscussionForumEditTopic_InternalLink =
  "/discussion-forum/edit-topic";
export const DiscussionForumThread_InternalLink = "/discussion-forum/thread";
export const Search_InternalLink = "/search";
export const ChooseHabits_InternalLink = "/goal-setting/choose-habits";
export const AddHabits_InternalLink = "/goal-setting/add-habits";
export const GoalSettingHomepage_InternalLink = "/goal-setting/homepage";
export const SetGoalMetrics_InternalLink = "/goal-setting/set-goal-metrics";
export const Achieveableslider_InternalLink =
  "/goal-setting/achieveable-slider";
export const ImportanceSlider_InternalLink = "/goal-setting/importance-slider";
export const YourOptions_InternalLink = "/decision-aid/hirsutism/your-options";
export const FactorsChoice_InternalLink = "/decision-aid/hirsutism/factors";
export const ExploreOptions_InternalLink =
  "/decision-aid/hirsutism/explore-options";
export const ContraceptivePill_InternalLink =
  "/decision-aid/hirsutism/options/contraceptive-pill";
export const Obstacles_InternalLink = "/goal-setting/obstacles";
export const Solutions_InternalLink = "/goal-setting/solutions";
export const SelectSolutions_InternalLink = "/goal-setting/select-solutions";
export const GoalReview_InternalLink = "/goal-setting/goal-review";
export const Hirsutism_InternalLink = "/decision-aid/hirsutism/";
export const DecisionAid_InternalLink = "/decision-aid/";

// <a href="https://pngtree.com/free-backgrounds">free background photos from pngtree.com</a>
export const DidYouKnow_SurveyLink = "https://bit.ly/2ZFNkHz";

export const AskPCOSPrivacyPolicy_Internal = "/terms-privacy/";
